<div class="dropdown">
  <div class="dropdown-header flex items-center">
    <div class="dropdown-heading-icon flex items-center justify-center">
      <mat-icon svgIcon="mat:person"></mat-icon>
    </div>
    <div>
      <div class="dropdown-heading leading-snug">{{ nombre() }}</div>
      <div *ngIf="email()" class="text-secondary text-xs leading-tight">
        {{ email() }}
      </div>
      <div *ngIf="rol()" class="text-primary-600 text-xs uppercase tracking-wide mt-0.5">
        {{ rol() }}
      </div>
    </div>
  </div>

  <div class="dropdown-footer flex items-center justify-end">
    <button mat-flat-button color="primary" (click)="salir()">
      <mat-icon svgIcon="mat:logout" class="mr-2"></mat-icon>
      Salir
    </button>
  </div>
</div>
